package fr.frux.core.common.di

import fr.frux.core.common.io.FileExporter
import fr.frux.core.common.io.createFileExporter
import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn

/**
 * Metro DI module providing FileExporter (#194), sur le modèle de TokenStorageModule.
 */
@ContributesTo(AppScope::class)
interface FileExporterModule {

    companion object {
        @Provides
        @SingleIn(AppScope::class)
        fun provideFileExporter(): FileExporter {
            return createFileExporter()
        }
    }
}
